"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Score = exports.SCORE_CONFIG = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
exports.SCORE_CONFIG = {
    feedbacksAverage: {
        min: 1,
        max: 5,
    },
};
let Score = class Score {
    constructor() {
        this.totalScore = 5;
        // The trip is declined/accepted ( for example 4 ): 5 of 100 is declined = score is 95%
        this.acceptanceScoreAverage = 5;
        // for ex. the penalty is 40EUR and trip cost is 200EUR, the penalty score 80% = 0.8 = 4stars
        this.penaltyScoreAverage = 5;
    }
};
exports.Score = Score;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((totalScore) => (totalScore >= 0 ? totalScore : 5)),
    __metadata("design:type", Number)
], Score.prototype, "totalScore", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(exports.SCORE_CONFIG.feedbacksAverage.min),
    (0, class_validator_1.Max)(exports.SCORE_CONFIG.feedbacksAverage.max),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Score.prototype, "feedbacksAverage", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Score.prototype, "acceptanceScoreAverage", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Score.prototype, "penaltyScoreAverage", void 0);
exports.Score = Score = __decorate([
    (0, class_transformer_1.Exclude)()
], Score);
//# sourceMappingURL=Score.js.map